//Reducer Types
export interface SettingState {
	contact?: {
		support_email?: String;
		support_phone?: String;
		support_country_code?: String;
	};

	notification?: {
		email?: 0 | 1;
		web?: 0 | 1;
	};

	subscription?: {
		is_active?: 0 | 1;
	};
}
export interface Setting {
	setting: SettingState;
}
interface ContactDetails {
	type: "SETTING_CONTACT_INFO";
	payload: {
		contact: {
			support_email: String;
			support_phone: String;
			support_country_code: String;
		};
	};
}

interface SettingSubscription {
	type: "SETTING_SUBSCRIPTION";
	payload: {
		subscription: {
			is_active: 0 | 1;
		};
	};
}
type Action = ContactDetails | SettingSubscription;

export const settingCountReducer = (
	state: SettingState = {
		contact: { support_email: undefined, support_phone: undefined, support_country_code: undefined },
		subscription: { is_active: 0 },
		notification: { email: 1, web: 1 },
	},
	action: Action
): SettingState => {
	switch (action.type) {
		case "SETTING_CONTACT_INFO":
			return {
				...state,
				contact: action.payload.contact,
			};
		case "SETTING_SUBSCRIPTION":
			return {
				...state,
				subscription: action.payload.subscription,
			};

		default:
			return state;
	}
};
